import { getAuth } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";
import { getRemoteConfig, fetchAndActivate, getValue } from "firebase/remote-config";
import { app } from "./config";
import { debugLog } from "@/lib/utils";
// Initialize Firebase services
// Using default getAuth() which uses localStorage persistence by default
export const auth = getAuth(app);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export const analytics = getAnalytics(app);

// Remote Config with defaults
export const remoteConfig = getRemoteConfig(app);
remoteConfig.settings.minimumFetchIntervalMillis = import.meta.env.DEV ? 0 : 900000; // 0 in dev, 15 minutes in prod
remoteConfig.defaultConfig = {
  allow_affiliates: false,
};

// Initialize Remote Config
export const initRemoteConfig = async () => {
  try {
    await fetchAndActivate(remoteConfig);
    debugLog("Remote Config fetched and activated");
  } catch (error) {
    debugLog("Remote Config fetch failed, using defaults", error);
  }
};

// Helper to get boolean config value
export const getRemoteConfigBoolean = (key: string): boolean => {
  return getValue(remoteConfig, key).asBoolean();
};

// Connect to emulators in development mode
if (import.meta.env.DEV && import.meta.env.VITE_SKIP_EMULATORS !== "true") {
  debugLog("Connecting to Firebase emulators...");
  // connectAuthEmulator(auth, "http://localhost:9099");
  connectFirestoreEmulator(db, "127.0.0.1", 8081);
  connectStorageEmulator(storage, "127.0.0.1", 9198);
  connectFunctionsEmulator(functions, "127.0.0.1", 5003);

  debugLog("Firebase emulators connected!");
} else {
  if (import.meta.env.DEV) {
    debugLog("Running in development mode, using Firebase services");
  }
}
